"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:7.2.0'] && _();
}
catch (e) { }
